import HttpService from "./http.service";

class PurchasesService {
  list = async (sortStr = null, filterStr = null) => {
    const purchasesEndpoint = `/purchases?limit=-1${sortStr ? sortStr : ""}${
      filterStr ? filterStr : ""
    }`;
    return await HttpService.get(purchasesEndpoint);
  };

  paginate = async (page = 0, limit = 25, sortStr = null, filterStr = null) => {
    const purchasesEndpoint = `/purchases?page=${page}&limit=${limit}${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(purchasesEndpoint);
  };

  get = async (id) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.get(`${purchasesEndpoint}/${id}`);
  };

  getPdf = async (id) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.getFile(`${purchasesEndpoint}/${id}/pdf`);
  };

  productReport = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const purchasesEndpoint = `/purchases/product-report?${query}`;
    return await HttpService.get(purchasesEndpoint, data);
  };

  productReportByMonth = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const purchasesEndpoint = `/purchases/product-report-by-month?${query}`;
    return await HttpService.get(purchasesEndpoint, data);
  };

  productPriceReportByMonthHandler = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const purchasesEndpoint = `/purchases/product-price-report-by-month?${query}`;
    return await HttpService.get(purchasesEndpoint, data);
  };

  filter = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const purchasesEndpoint = `/purchases/filter?${query}`;
    return await HttpService.get(purchasesEndpoint, data);
  };

  create = async (data) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.post(purchasesEndpoint, data);
  };

  update = async (id, data) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.put(`${purchasesEndpoint}/${id}`, data);
  };

  patch = async (id, data) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.patch(`${purchasesEndpoint}/${id}`, data);
  };

  delete = async (id) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.delete(`${purchasesEndpoint}/${id}`);
  };

  logs = async (id) => {
    const purchasesEndpoint = "/purchases";
    return await HttpService.get(`${purchasesEndpoint}/${id}/logs`);
  };
}

export default new PurchasesService();
